import React from 'react';
import { Tooltip as ReactTooltip } from 'react-tooltip';

type GasConsumptionData = {
  period: string;
  actual: number;
  projected: number;
  redHeight: string;
  blueHeight: string;
  cost: string;
};

type GasConsumptionCostProps = {
  data: GasConsumptionData[];
};

const GasConsumptionCost: React.FC<GasConsumptionCostProps> = ({ data }) => {
  return (
    <div className="container mx-auto flex grow flex-col px-4">
      <h2 className="mb-3 py-2 text-3xl uppercase">
        Current Total Consumption/Cost for Gas
      </h2>
      <div className="relative flex grow items-end">
          {/* Y-axis label */}
          <div className="absolute -left-8 flex h-full items-center">
          <span className="transform -rotate-90 text-sm font-medium">MCF</span>
        </div>
        {data.map((item, index) => (
          <div
            key={index}
            className="flex h-full w-[20%] flex-col items-center"
          >
            <h3 className="my-2">{item.period}</h3>
            <div className="flex h-full items-end">
              <div
                data-tooltip-id="valueTooltip"
                data-tooltip-content={`Actual: ${item.actual.toFixed(2)}`}
                className="transition-height mx-0.5 w-20 bg-red-500 duration-500 ease-in-out "
                style={{ height: item.redHeight }}
              ></div>
              <div
                data-tooltip-id="valueTooltip"
                data-tooltip-content={`Projected: ${item.projected.toFixed(2)}`}
                className="transition-height mx-0.5 w-20 bg-blue-500 duration-500 ease-in-out "
                style={{ height: item.blueHeight }}
              ></div>
            </div>
            <div className="h-0.5 w-full bg-gray-400 "></div>{' '}
            {/* Line at the bottom */}
          </div>
        ))}
        {data.slice(0, -1).map((_, index) => (
          <div
            key={index}
            className="left-1/5 absolute h-full w-px bg-gray-400"
            style={{ left: `${(index + 1) * 20}%` }}
          ></div>
        ))}
      </div>
      <div className="flex">
        {data.map((item, index) => (
          <div key={index} className="w-[20%] text-center">
            <span className="my-2">{item.cost}</span>
          </div>
        ))}
      </div>
      <ReactTooltip id="valueTooltip" />
    </div>
  );
};

export default GasConsumptionCost;
